const REQUIRED_CLAIM_FIELDS = ["agentId", "modelVersion", "configurationVersion", "agentRunId"];

/** Unclaimed session shell - GF04 doesn't pick which model plays. */
export function createAgentSession() {
  return {
    controllerType: "agent",
    agentId: null,
    modelVersion: null,
    configurationVersion: null,
    agentRunId: null,
    startedAt: Math.round(performance.now()),
  };
}

/** Fills in the identity from session.ready. Mutates in place so existing references pick it up. */
export function claimAgentSession(session, { agentId, modelVersion, configurationVersion, agentRunId }) {
  const fields = { agentId, modelVersion, configurationVersion, agentRunId };
  const missing = REQUIRED_CLAIM_FIELDS.filter((field) => !fields[field]);
  if (missing.length) {
    throw new Error(`[aiAgent] session.ready is missing required field(s): ${missing.join(", ")}`);
  }
  Object.assign(session, fields);
  return session;
}
